/* Avuneli: revelado suave al hacer scroll. Sin dependencias. Si falla, todo queda visible. */
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('lp-js');

  var targets = [];
  function add(nodes, step, img) {
    Array.prototype.forEach.call(nodes, function (el, i) {
      if (el.classList.contains('lp-rv')) return;
      el.classList.add('lp-rv');
      if (img) el.classList.add('lp-rv--img');
      el.style.setProperty('--lp-d', Math.min(i * step, 360) + 'ms');
      targets.push(el);
    });
  }

  // Todo menos el hero (esta sobre el pliegue)
  var sections = document.querySelectorAll('.lp-section:not(.lp-hero), .lp-closing-sec');
  Array.prototype.forEach.call(sections, function (s) {
    add(s.querySelectorAll('.lp-intro, .lp-h2, .lp-lead, .lp-closing, .lp-note-box, .lp-cta-block, .lp-steps'), 0, false);
    add(s.querySelectorAll('.lp-lines > li, .lp-pillars > li, .lp-proof > li, .lp-steps > li, .lp-notes > li, .lp-edu > li, .lp-ticks > li'), 90, false);
    add(s.querySelectorAll('.lp-media, .lp-diagram, .lp-facts, .lp-buybox, .lp-compare, .lp-cmp3__table, .lp-std__photo, .lp-gallery'), 0, true);
  });
  add(document.querySelectorAll('.lp-faq details'), 50, false);

  function show(el) { el.classList.add('is-in'); if (io) io.unobserve(el); }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      // Visible, o ya por encima del viewport (salto de ancla, scroll rapido): nunca se queda oculto
      if (e.isIntersecting || e.boundingClientRect.top < 0) show(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (el) { io.observe(el); });

  // Red de seguridad: lo que ya quedo atras o dentro de pantalla se muestra aunque el observador falle
  var timer;
  function sweep() {
    targets.forEach(function (el) {
      if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < window.innerHeight * 0.98) show(el);
    });
  }
  window.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(sweep, 160); }, { passive: true });
  setTimeout(sweep, 1800);

})();
